<template>
  <div>
    <section id="wrapCont">
      <section id="check" class="check_bg" v-if="reservationInfo">
        <div class="partner_info">
          <div class="reserve_info">
            {{ ccName }}
            <p>
              <strong>{{ $t("main.reservationStateList") }}</strong>
            </p>
            <div class="refresh" @click="fetchAll" />
          </div>
        </div>
        <div class="partner_box">
          <dl class="dl_reserve_list">
            <dt>{{ $t("main.reservationStateList") }}</dt>
            <dd>
              {{ reservationInfo.tgResveMember.resveName
              }}<span class="state state_ok">{{ timeLists.length }}팀</span>
            </dd>
            <dt>{{ $t("main.reservationDate") }}</dt>
            <dd>
              {{
                reservationInfo.insertDt.split(" ")[0] +
                ` (${getDayOfWeek(reservationInfo.insertDt)})`
              }}
            </dd>
            <dt>{{ $t("main.reservationNo") }}</dt>
            <dd>{{ reservationInfo.resveNo }}</dd>
          </dl>
          <div class="bl_state">
            <div class="main_btn_wrap is_moBody">
              <!-- 본인 활성: is_acMe -->
              <template v-for="(time, idx) in timeLists">
                <div
                  v-if="time.resveDateFlag"
                  :key="idx + 10"
                  class="date-indicator"
                >
                  {{ time.tgResveTime.resveDate }}
                </div>
                <a
                  :key="idx"
                  class="btn_basic btn_checkin"
                  :class="{
                    is_acMe: isMyReservation(time),
                  }"
                  :style="
                    time.resveId === $route.params.reservationId
                      ? { borderWidth: '2px', borderColor: '#4db4ac' }
                      : {}
                  "
                  @click="onClickReservationTime(time)"
                >
                  <div class="bl_state_info">
                    {{
                      `${time.tgResveTime.resveTime} ${getCourseName(
                        time.tgResveTime.resveCourse
                      )}`
                    }}
                  </div>
                  <div class="bl_state_num">
                    <span
                      class="circle-base"
                      :class="{
                        'is-full-time-circle':
                          Number(time.visitCnt) === time.tgResveCmpns.length,
                      }"
                      >{{ time.tgResveCmpns.length }} 명</span
                    >
                  </div>
                </a>
              </template>
            </div>
          </div>
        </div>
        <div class="main_btn_wrap is_moFooter">
          <p class="check_info">
            <span class="ico"></span> 예약코스/타임을 선택하면 동반자 등록
            화면으로 이동합니다.
          </p>
          <p class="check_info">
            <span class="ico"></span> <span class="bl_me"></span> 예약자가 등록
            된 타임입니다.
          </p>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import commonCodesMixin, { getCourseName } from "@/mixins/commonCodesMixin";
import checkInMixin from "@/mixins/checkInMixin";

export default {
  name: "ReservationStatusByGroup",
  mixins: [commonCodesMixin, checkInMixin],
  data() {
    return {
      timeLists: [],
    };
  },
  async mounted() {
    await this.fetchAll();
  },
  methods: {
    getCourseName,
    async fetchAll() {
      await this.fetch("GRP");
      this.timeLists.reduce((acc, time) => {
        if (acc.includes(time.tgResveTime.resveDate)) {
          time["resveDateFlag"] = false;
        } else {
          time["resveDateFlag"] = true;
          acc.push(time.tgResveTime.resveDate);
        }
        return acc;
      }, []);
      await this.$forceUpdate();
    },
    async onClickReservationTime(timeData) {
      await this.$router.push({
        name: "ReservationStatus",
        params: {
          reservationId: timeData.resveId,
        },
      });
    },
    isMyReservation(time) {
      return time.tgResveCmpns?.find(
        (member) =>
          member.cmpnName === this.reservationInfo.tgResveMember.contactName
      );
    },
    getDayOfWeek(date) {
      const days = ["일", "월", "화", "수", "목", "금", "토"];
      return days[new Date(date).getDay()];
    },
  },
  computed: {
    ...mapGetters(["ccName"]),
  },
};
</script>

<style scoped>
#check {
  min-height: 100vh;
}

#check span.state.state_ok {
  background: none;
  border: 1px solid #4db4ac;
  box-sizing: border-box;
  color: #4db4ac;
  margin-left: 12px;
  padding: 0 12px;
  width: auto;
}

#check .dl_reserve_list {
  margin-bottom: 0;
}

#check .main_btn_wrap.is_moBody {
  padding-bottom: 15px;
  padding-top: 30px;
}

#check .main_btn_wrap.is_moFooter {
  padding-bottom: 18px;
  padding-top: 16px;
}

#check .bl_state {
  max-height: auto;
  overflow: auto;
}

#check a.btn_basic.btn_checkin {
  display: flex;
  position: relative;
  justify-content: space-between;
  padding-left: 11px;
  padding-right: 20px;
}

#check div.date-indicator {
  margin-bottom: 6px;
  color: #4db4ac;
  font-size: 16px;
}

#check a.btn_basic.btn_checkin.is_acMe {
  color: #4db4ac;
}

#check a.btn_basic.btn_checkin:before {
  display: none;
}

#check .bl_state_info {
  flex: 0 0 auto;
  padding-left: 25px;
  position: relative;
}

#check .bl_state_info::before {
  background: transparent
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAVCAYAAAC+NTVfAAAAAXNSR0IArs4c6QAAA21JREFUSEu9ll9sU2UYxn/vWdu1MrpVptPhwphDxcQgievWYaRmaoIhyNhcYt2mXhAvjKLcKZr0ZsaYmMAgJJglBAOS4AaDKETiQjGk7RYM/okuZjj+uQhebLNk7bq15zMt2drS07PYC8/VOed93uf3nXOe92uFIg/lR7u6ymurvRaYEz96MTZSTNPoPveKh1zajTK7OBJJEpNReazq9eAf/9WrOPhet29VpXbEYbvTPj2T3OvqHnnnf4H/2tv4eLlD/VLtKtEQmIwmWyu7RgaLgp/zey3r6mL7NUFFo4n3qt/8IbqU0dQh92cJXXZaLeyv6Bp+ayn9lYNeu8syu08pNVthv71TOn6bS7+3P/sadq90WXakzmfiaqzMF37EzEyd81qYjP8O1AHj3Fv6qDwbSJj1TPS5v612lbyQ0kRifFPeGdqchl8/0Hi6plLblDqfT6p5W0fYZgrv97yC8OWiRuGT9tBRs57rBxomaiot1SlNNK6uLfOFa9Pw0d6G7fc5tc+dDiGeYLLMKo3SEbpsZKYUwvGmSyDrMnX1E9vC60VQhj3HPPU3I8kzVqvUO+3CzKze53ptZPti2kf3NDSvXFHy6XKHbADmQHYTS/ZI53Ak21CdaNqELqfzIJp6UVrDZ3K0JzcsJ6E+BPUuYLsdVRcmphMfrX37YiClyxk1NdDcA+qDLINbiLzPz8FDCxuJGvCcB54xeMLvpS20MXU/tQHxRFM3yCdAVUYrH0tbcNfCdS78eNOrKDlsYHwRnR2UiEKp4GK9djNc/TrLW5pJKkFjD/BUno+oTtkWPmIMP9H8JLq6ZBKcm8AD6bpzNTx3GL7rgsj4QkumbmSiyXppDf5oDD/oteOMzwBawQXc74a6reBaC44qiN2CqVEYH4S/R8wCrxMpXSZvBGYN4envNeAZA+oLumhWaOyBB5/OSP66AMO7QJ83g1+WttCabEHe3q76PYMIL5m5UF4PLV9kJEPd8I/hZGZNIyelPbTVHJ6f+Px11DwPa3xw5RSs3gJjR+HGWdP1Qm7S80Yt/doLJz5jXuqC+HRKfWdaSysgPmUOvyvpxvClE7/EExYo35V0Q3h0qL1X0/WO4giFu3RNO3ZPS3/Ob35e4GJDL5unvfhVjTtavnrYPHB+v8bGQOE5LxZ+3quL35/zX+9fVPEvJdFaHnsAAAAASUVORK5CYII=")
    no-repeat center center / contain;
  content: "본인";
  display: none;
  height: 14px;
  left: 0;
  overflow: hidden;
  position: absolute;
  text-indent: -1000rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
}

#check a.btn_basic.btn_checkin.is_acMe .bl_state_info::before {
  display: block;
}

#check .bl_state_num {
  flex: 0 0 auto;
  position: relative;
  align-content: center;
  margin: auto 0;
}

#check .circle-base {
  padding: 6px 18px;
  border-radius: 30px;
  border: 1px solid #4db4ac;
}

#check .is-full-time-circle {
  background-color: #4db4ac;
  color: white;
}

#check p.check_info {
  font-size: 13px;
  margin: 0;
  padding-left: 24px;
  padding-top: 2px;
  text-align: left;
  text-indent: -24px;
}

#check .bl_me {
  background: transparent
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAVCAYAAAC+NTVfAAAAAXNSR0IArs4c6QAAA21JREFUSEu9ll9sU2UYxn/vWdu1MrpVptPhwphDxcQgievWYaRmaoIhyNhcYt2mXhAvjKLcKZr0ZsaYmMAgJJglBAOS4AaDKETiQjGk7RYM/okuZjj+uQhebLNk7bq15zMt2drS07PYC8/VOed93uf3nXOe92uFIg/lR7u6ymurvRaYEz96MTZSTNPoPveKh1zajTK7OBJJEpNReazq9eAf/9WrOPhet29VpXbEYbvTPj2T3OvqHnnnf4H/2tv4eLlD/VLtKtEQmIwmWyu7RgaLgp/zey3r6mL7NUFFo4n3qt/8IbqU0dQh92cJXXZaLeyv6Bp+ayn9lYNeu8syu08pNVthv71TOn6bS7+3P/sadq90WXakzmfiaqzMF37EzEyd81qYjP8O1AHj3Fv6qDwbSJj1TPS5v612lbyQ0kRifFPeGdqchl8/0Hi6plLblDqfT6p5W0fYZgrv97yC8OWiRuGT9tBRs57rBxomaiot1SlNNK6uLfOFa9Pw0d6G7fc5tc+dDiGeYLLMKo3SEbpsZKYUwvGmSyDrMnX1E9vC60VQhj3HPPU3I8kzVqvUO+3CzKze53ptZPti2kf3NDSvXFHy6XKHbADmQHYTS/ZI53Ak21CdaNqELqfzIJp6UVrDZ3K0JzcsJ6E+BPUuYLsdVRcmphMfrX37YiClyxk1NdDcA+qDLINbiLzPz8FDCxuJGvCcB54xeMLvpS20MXU/tQHxRFM3yCdAVUYrH0tbcNfCdS78eNOrKDlsYHwRnR2UiEKp4GK9djNc/TrLW5pJKkFjD/BUno+oTtkWPmIMP9H8JLq6ZBKcm8AD6bpzNTx3GL7rgsj4QkumbmSiyXppDf5oDD/oteOMzwBawQXc74a6reBaC44qiN2CqVEYH4S/R8wCrxMpXSZvBGYN4envNeAZA+oLumhWaOyBB5/OSP66AMO7QJ83g1+WttCabEHe3q76PYMIL5m5UF4PLV9kJEPd8I/hZGZNIyelPbTVHJ6f+Px11DwPa3xw5RSs3gJjR+HGWdP1Qm7S80Yt/doLJz5jXuqC+HRKfWdaSysgPmUOvyvpxvClE7/EExYo35V0Q3h0qL1X0/WO4giFu3RNO3ZPS3/Ob35e4GJDL5unvfhVjTtavnrYPHB+v8bGQOE5LxZ+3quL35/zX+9fVPEvJdFaHnsAAAAASUVORK5CYII=")
    no-repeat center center / contain;
  content: "본인";
  display: inline-block;
  height: 10px;
  overflow: hidden;
  text-indent: -1000rem;
  width: 15px;
}
</style>
